<template>
<div>
<querytitle>
  <template slot="queryleft">
    <div>模糊查找：</div>
    <div><el-input v-model="querykey" size="mini"></el-input></div>
    <div><el-button type="primary" size="mini" @click="getlist()">查找</el-button></div>
  </template>
  <template slot="queryright">
    <el-button type="primary" size="mini" @click="add()">新增</el-button>
    <fileimportbutton :par="pars" :classname="'sys_users'" :okupload="uploaded"></fileimportbutton>
  </template>
</querytitle>
<el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
  <el-table-column prop="uid" label="用户编号" width="100"></el-table-column>
  <el-table-column prop="uname" label="用户名" width="200"></el-table-column>
  <el-table-column prop="utel" label="手机号码" width="100"></el-table-column>
  <el-table-column prop="uemail" label="邮箱" width="150"></el-table-column>
  <el-table-column prop="areaname" label="行政区域" width="150"></el-table-column>
  <el-table-column prop="orgname" label="组织机构" width="150"></el-table-column>
  <el-table-column prop="LastErrorDateTime" label="最后错误时间" width="100"></el-table-column>
  <el-table-column prop="ErrorTimes" label="错误次数" width="100"></el-table-column>
  <el-table-column prop="wxid" label="微信号" width="100"></el-table-column>
  <el-table-column prop="uaddress" label="住址"></el-table-column>
  <el-table-column fixed="right" label="操作" width="150">
    <template slot-scope="scope">
     <el-button @click="edit(scope)" type="primary" size="mini">编辑</el-button>
      <el-button type="danger" size="mini" @click="del(scope)">删除</el-button>
    </template>
  </el-table-column>
</el-table>
<el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="rt">
</el-pagination>
<el-dialog title="用户信息" :visible="dialogFormVisible" :show-close="false" width="80%">
<el-form label-width="100px">
  <el-row>
    <el-col :span="8">
      <el-form-item label="用户编号">
        <el-input v-model="itemedit.uid" @input="inputmethod()"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item label="用户名">
        <el-input v-model="itemedit.uname" @input="inputmethod()"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item label="手机号码">
        <el-input v-model="itemedit.utel" @input="inputmethod()"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item label="密码">
        <el-input v-model="itemedit.upwd" @input="inputmethod()" type="password"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item label="确认密码">
        <el-input v-model="itemedit.upwd1" @input="inputmethod()" type="password"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item label="邮箱">
        <el-input v-model="itemedit.uemail" @input="inputmethod()"></el-input>
      </el-form-item>
    </el-col>
  </el-row>
  <el-row v-if="CU.cu.utype=='平台管理员'">
  <el-col :span="8">
  <el-form-item label="行政区域代码">
    <el-cascader v-model="itemedit.areaid"
    :options="areas"
    :props="{ value:'value',label:'text',checkStrictly: true }"
    @change="areaChange"></el-cascader>
  </el-form-item>
  </el-col>
  <el-col :span="8">
  <el-form-item label="机构代码">
    <el-select v-model="itemedit.orgid" placeholder="请选择" ref="orgselect">
      <el-option
        v-for="item in orgs"
        :key="item.orgid"
        :label="item.orgname"
        :value="item.orgid">
      </el-option>
    </el-select>
  </el-form-item>
  </el-col>
  <el-col :span="8">
  <el-form-item label="用户角色">
    <el-select v-model="itemedit.srid" placeholder="请选择">
      <el-option
        v-for="item in roles"
        :key="item.srid"
        :label="item.srname"
        :value="item.srid">
      </el-option>
    </el-select>
  </el-form-item>
  </el-col>
  </el-row>
  <el-form-item label="住址">
    <el-input v-model="itemedit.uaddress" @input="inputmethod()"></el-input>
  </el-form-item>

</el-form>
<div slot="footer" class="dialog-footer">
 <el-button @click="dialogFormVisible=false">取 消</el-button>
 <el-button type="primary" @click="postdata()">确 定</el-button>
</div>

</el-dialog>
</div>
</template>
<script>
import querytitle from '@/components/querytitle'
import fileimportbutton from '@/components/fileimportbutton'
export default {
components: {
  querytitle,fileimportbutton
},
data() {
  return {
    hh: 500,
    loading:false,
    addflag: false,
    itemlist: [],
    itemindex: 0,
    itemedit: {},
    dialogFormVisible: false,
    rt: 0,
    currentPage: 1,
    pagesize: 10,
    pars:{objname:'sys_users'},
    querykey:"",
    areas:[],
    orgs:[],
    roles:[],
  };
},
created() {
  this.hh = document.documentElement.clientHeight - 220;
  this.getlist();
  let that = this
  let pars = {}
  if(that.CU.cu.utype == '平台管理员')
      pars = {}
  that.GetData('SYS/GetCurrentAreas',pars,function(res){
    that.areas = res.data.areas
  },function(err){})
  this.getroles();
},
methods: {
  areaChange(value){
    let that = this
    that.itemedit.areaname =''
    for(var item of value){
      var xx =that.getnode(null,that.areas,'value',item)
      that.itemedit.arealevel = xx.node.level;
      that.itemedit.areaid = xx.node.value;
      if(that.itemedit.areaname)
        that.itemedit.areaname += "/" + xx.node.text
      else
        that.itemedit.areaname = xx.node.text
    }
    this.getorgs();
  },
  getorgs(){
       let that = this
        let wherestring = [{field: 'areaid',sym: 'like',val: that.itemedit.areaid+'%',oper: 'and'}]
        let pars = {objname: "sys_org",wheres: wherestring,PageSize: 100,CurrentPage: 1}
        that.PostData("Common/GETLIST", pars,function (res) {
          that.orgs = res.data.data;
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
  },
  getroles(){
       let that = this
        let wherestring = []
        let pars = {objname: "sys_roles",wheres: wherestring,PageSize: 100,CurrentPage: 1}
        that.PostData("Common/GETLIST", pars,function (res) {
          that.roles = res.data.data;
          if(that.CU.cu.utype != '平台管理员')
            that.roles.splice(0,1);
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
  },
  add() {
    this.addflag = true;
    this.itemedit.uid = "";
    this.itemedit.utype="单位管理员";
    if(this.CU.cu.utype == '单位管理员'){
      this.itemedit.orgid = this.CU.cu.orgid
      this.itemedit.orgname = this.CU.cu.orgname
      this.itemedit.areaid = this.CU.cu.areaid
      this.itemedit.areaname = this.CU.cu.areaname
    }
    this.itemedit.ustate = '启用'
    this.dialogFormVisible = true;
  },
  edit(par) {
    this.addflag = false;
    this.itemindex = par.$index;
    this.itemedit = Object.assign({}, par.row);
    this.itemedit.upwd1 = this.itemedit.upwd;
    this.getorgs();
    this.dialogFormVisible = true;
  },
  del: function (par) {
    let that = this;
    that.$confirm("确定要删除当前行吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        var pars = {objname: "sys_users",model: par.row};
        that.PostData("Common/DEL",pars,function (res) {
            if (res.data.error_code != 0) {
             that.$alert(res.data.message, {title: "错误"});
             return;
             }
             that.itemlist.splice(par.$index, 1);
          },function (err) {
            that.$alert(err, {title: "错误",type: 'error'});
          }
        );
      })
      .catch(() => {});
    },
    postdata() {
      let that = this;
      if (!that.itemedit.uid) {
        that.$alert("代码不能为空", {title: "提示"});return;
      }
      that.itemedit.orgname = that.$refs.orgselect.selected.label
      let pars = {objname: "sys_users",model: Object.assign({}, that.itemedit)};
      if (that.addflag) {
          that.PostData("Common/ADD",pars,function (res) {
            if (res.data.error_code != 0) {
              that.$alert(res.data.message, {title: "错误"});return;
            }
            that.itemlist.push(pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      } else {
        that.PostData("Common/EDIT",pars,function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, {title: "错误"});return;
          }
          that.$set(that.itemlist, that.itemindex, pars.model);
          that.dialogFormVisible = false;
        },function (err) {
          that.$alert(err, {title: "错误",type: 'error'});
        });
      }
    },
    getlist() {
        let that = this
        let wherestring = []
        if(that.CU.cu.utype == '平台管理员')
           wherestring = [{field: 'uname',sym: 'like',val: this.querykey+'%',oper: ''},]
        else
          wherestring = [{field: 'orgid',sym: '=',val: that.CU.cu.orgid,oper: 'and'}]
        // if(this.querykey){
        //   wherestring = [{field: 'orgid',sym: '=',val: that.CU.cu.orgid,oper: 'and'}]
        // }
        let pars = {objname: "sys_users",wheres: wherestring,PageSize: that.pagesize,CurrentPage: that.currentPage}
        that.PostData("Common/GETLIST", pars,function (res) {
          that.itemlist = res.data.data;
          that.rt = res.data.rowTotal
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
    uploaded(){
      this.getlist()
    }
  }
};
</script>
